import { render, staticRenderFns } from "./EditUserPermissions.vue?vue&type=template&id=3207c1c0&scoped=true&"
import script from "./EditUserPermissions.vue?vue&type=script&lang=ts&"
export * from "./EditUserPermissions.vue?vue&type=script&lang=ts&"
import style0 from "./EditUserPermissions.vue?vue&type=style&index=0&id=3207c1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3207c1c0",
  null
  
)

export default component.exports